import React from 'react';
import 'assets/styles/navbar.css';
import { WideContainer} from 'components/mui/containers/PxftContainer';
import { Button, Grid, Link } from '@mui/material';
import LogoSvg from 'components/logoSvg/logoSvg';
import HeaderNavigation from 'components/HeaderNavigation/HeaderNavigation';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useNavCtaClaimed, useNavCtaHref } from 'context/NavCtaContext';
import { startHref } from 'helpers/portalSession';


/**
 * @param {boolean} [minimal] strip the bar back to the logo and a way in.
 *        For conversion pages (the referral invite), where "Get Started"
 *        duplicates the page's own primary CTA and — unlike that one — carries
 *        no referral code, and the section menus are six ways to leave.
 */
const NavigationBar = ({ minimal = false }) => {
    // a landing page may point "Get Started" at its own primary action (NavCtaContext)
    const getStartedHref = useNavCtaHref(startHref(window.location.search));
    // a minimal header drops "Get Started" as a duplicate of the page's own CTA —
    // unless the page has made the button that CTA, which is then worth keeping
    const ctaClaimed = useNavCtaClaimed();

const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.down('md'));
const navigate = useNavigate();

const WindowMenu= () =>{
return(
  <Grid container className='nav-navi-contents'>
    <Grid item md={9} xs={12} className='center-align'>
      <Grid container justifyContent={{md:'left',xs:'space-between'}} className='center-align'>
          <Grid item pr={4} display='flex' alignItems='center' justifyContent='left' className='center-align' onClick={()=>{window.location.href="https://younet.ai"}} style={{cursor:'pointer'}}>
          <LogoSvg/>
        </Grid >
        {/* On mobile HeaderNavigation IS the hamburger, and it carries the only
            sign-in route at that size — so `minimal` drops the desktop section
            menus and leaves the collapsed mobile one alone. */}
        {(!minimal || isMobile) && <HeaderNavigation/>}
      </Grid>
    </Grid>
    <Grid item md={3} xs={0} className='center-align' style={{justifyContent:'flex-end'}}>
    {!isMobile &&
    <div style={{display:'flex', alignItems:'center'}}>
      <Link href='https://younet.ai/portal/login' rel="noreferrer" className='navibtn'><Button sx={{color:'var(--ynt-primary)',width:100, height:50,mx:2}}>Sign in</Button></Link>
      {(!minimal || ctaClaimed) &&
      <Link href={getStartedHref} rel="noreferrer" className='navibtn'><Button variant="outlined" sx={{color:'var(--ynt-primary)',width:160, height:50,border:'2px solid'}}>Get Started</Button></Link>
      }
    </div>
    }
    </Grid>
    </Grid>
);
}

    return(
      <div>
        <WideContainer className='nav'>
          <div className='center-align'>
              {WindowMenu()}
          </div>
        </WideContainer>
      </div>
    );

}
export default NavigationBar;